export async function registerAndPrepareTargetFiles(files, callbacks) {
  const pendingFiles = files.filter((file) => !callbacks.isRegistered(file))

  pendingFiles.forEach((file) => {
    callbacks.register(file)
    callbacks.createPreview(file)
    callbacks.dispatchFileType(file)
  })

  await Promise.all(pendingFiles.map(async (file) => {
    await callbacks.processMetadata(file)
    callbacks.metadataReady?.(file)
  }))

  return pendingFiles
}
